import {
  ChatLoader,
  ChatMessage as ChatMessagePrimitive,
  TextShimmer,
} from '@heroui-pro/react';
import { Markdown } from '@heroui-pro/react/markdown';
import type { AiChatUiMessage } from '../types';
import { AiChatAttachmentList } from './AiChatAttachmentList';

export type AiChatThreadMessageProps = {
  message: AiChatUiMessage;
};

export function AiChatThreadMessage({ message }: AiChatThreadMessageProps) {
  if (message.role === 'user') {
    return (
      <ChatMessagePrimitive.User>
        {message.attachments?.length ? (
          <AiChatAttachmentList attachments={message.attachments} className="mb-2" />
        ) : null}
        <ChatMessagePrimitive.Bubble>
          <ChatMessagePrimitive.Content>{message.text}</ChatMessagePrimitive.Content>
        </ChatMessagePrimitive.Bubble>
      </ChatMessagePrimitive.User>
    );
  }

  return (
    <ChatMessagePrimitive.Assistant>
      <ChatMessagePrimitive.Body>
        {message.status === 'streaming' ? (
          <>
            {message.text ? <TextShimmer>{message.text}</TextShimmer> : null}
            <ChatLoader.Dots />
          </>
        ) : message.status === 'failed' ? (
          <ChatMessagePrimitive.Content className="text-danger">
            {message.text || '生成失败，请重试'}
          </ChatMessagePrimitive.Content>
        ) : (
          <>
            {message.text ? (
              <ChatMessagePrimitive.Content>
                <Markdown>{message.text}</Markdown>
              </ChatMessagePrimitive.Content>
            ) : null}
            {message.images?.map((img, index) => (
              <ChatMessagePrimitive.Media key={`${img.src}-${index}`}>
                <img
                  alt={img.alt ?? '生成图片'}
                  className="max-h-[480px] max-w-full rounded-2xl object-contain"
                  src={img.src}
                />
              </ChatMessagePrimitive.Media>
            ))}
          </>
        )}
      </ChatMessagePrimitive.Body>
    </ChatMessagePrimitive.Assistant>
  );
}
